var _path, _mask, _ellipse, _path2, _mask2, _ellipse2, _path3, _mask3, _ellipse3, _path4, _mask4, _ellipse4, _path5, _mask5, _ellipse5, _path6, _mask6, _ellipse6, _path7, _mask7, _ellipse7, _path8, _mask8, _ellipse8, _path9, _mask9, _ellipse9, _path10, _mask10, _ellipse10, _path11, _mask11, _ellipse11, _path12, _mask12, _ellipse12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelsRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78571 12.1778H1.5V28.4844H5.78571M5.78571 12.1778V6.85317H8.07182M5.78571 12.1778V28.4844M21.8571 28.4844H26.5V11.5122H21.8571M21.8571 28.4844V11.5122M21.8571 28.4844H18.2857M21.8571 11.5122V6.85317H19.7143M19.7143 6.85317C19.7143 6.85317 19.7143 6.85317 19.7143 3.52531C19.7143 2.61356 18.2857 1.62815 17.2143 1.5286C16.5213 1.46422 12.9002 1.48315 10.4286 1.50455C9.07879 1.51624 8.21508 2.52702 8.07182 3.19259C7.92857 3.85817 8.07182 6.85317 8.07182 6.85317M19.7143 6.85317H8.07182M5.78571 28.4844H10.0714M18.2857 28.4844V23.8253H14.1786M18.2857 28.4844H14.1786M10.0714 28.4844V23.8253H14.1786M10.0714 28.4844H14.1786M14.1786 28.4844V23.8253",
    stroke: "#AB0101",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 10.181C9.14286 9.4971 9.69398 9.17934 10.0714 9.17934V13.1793C11.6323 13.1793 13.1429 11.9676 13.1429 10.181H9.14286ZM10.0714 9.17934C10.4489 9.17934 11 9.4971 11 10.181H7C7 11.9676 8.51052 13.1793 10.0714 13.1793V9.17934ZM11 10.181C11 10.8649 10.4489 11.1826 10.0714 11.1826V7.18262C8.51052 7.18262 7 8.39433 7 10.181H11ZM10.0714 11.1826C9.69398 11.1826 9.14286 10.8649 9.14286 10.181H13.1429C13.1429 8.39433 11.6323 7.18262 10.0714 7.18262V11.1826Z",
    fill: "#AB0101",
    mask: "url(#path-2-inside-1_799_2202)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0706 10.181C13.0706 9.4971 13.6217 9.17934 13.9992 9.17934V13.1793C15.5601 13.1793 17.0706 11.9676 17.0706 10.181H13.0706ZM13.9992 9.17934C14.3766 9.17934 14.9277 9.4971 14.9277 10.181H10.9277C10.9277 11.9676 12.4383 13.1793 13.9992 13.1793V9.17934ZM14.9277 10.181C14.9277 10.8649 14.3766 11.1826 13.9992 11.1826V7.18262C12.4383 7.18262 10.9277 8.39433 10.9277 10.181H14.9277ZM13.9992 11.1826C13.6217 11.1826 13.0706 10.8649 13.0706 10.181H17.0706C17.0706 8.39433 15.5601 7.18262 13.9992 7.18262V11.1826Z",
    fill: "#AB0101",
    mask: "url(#path-4-inside-2_799_2202)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 10.181,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 10.181C17.0003 9.4971 17.5514 9.17934 17.9289 9.17934V13.1793C19.4898 13.1793 21.0003 11.9676 21.0003 10.181H17.0003ZM17.9289 9.17934C18.3063 9.17934 18.8574 9.4971 18.8574 10.181H14.8574C14.8574 11.9676 16.3679 13.1793 17.9289 13.1793V9.17934ZM18.8574 10.181C18.8574 10.8649 18.3063 11.1826 17.9289 11.1826V7.18262C16.3679 7.18262 14.8574 8.39433 14.8574 10.181H18.8574ZM17.9289 11.1826C17.5514 11.1826 17.0003 10.8649 17.0003 10.181H21.0003C21.0003 8.39433 19.4898 7.18262 17.9289 7.18262V11.1826Z",
    fill: "#AB0101",
    mask: "url(#path-6-inside-3_799_2202)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 17.1693C9.14286 16.4854 9.69398 16.1676 10.0714 16.1676V20.1676C11.6323 20.1676 13.1429 18.9559 13.1429 17.1693H9.14286ZM10.0714 16.1676C10.4489 16.1676 11 16.4854 11 17.1693H7C7 18.9559 8.51052 20.1676 10.0714 20.1676V16.1676ZM11 17.1693C11 17.8531 10.4489 18.1709 10.0714 18.1709V14.1709C8.51052 14.1709 7 15.3826 7 17.1693H11ZM10.0714 18.1709C9.69398 18.1709 9.14286 17.8531 9.14286 17.1693H13.1429C13.1429 15.3826 11.6323 14.1709 10.0714 14.1709V18.1709Z",
    fill: "#AB0101",
    mask: "url(#path-8-inside-4_799_2202)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0011,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0011,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0725 17.1693C13.0725 16.4854 13.6237 16.1676 14.0011 16.1676V20.1676C15.562 20.1676 17.0725 18.9559 17.0725 17.1693H13.0725ZM14.0011 16.1676C14.3786 16.1676 14.9297 16.4854 14.9297 17.1693H10.9297C10.9297 18.9559 12.4402 20.1676 14.0011 20.1676V16.1676ZM14.9297 17.1693C14.9297 17.8531 14.3786 18.1709 14.0011 18.1709V14.1709C12.4402 14.1709 10.9297 15.3826 10.9297 17.1693H14.9297ZM14.0011 18.1709C13.6237 18.1709 13.0725 17.8531 13.0725 17.1693H17.0725C17.0725 15.3826 15.562 14.1709 14.0011 14.1709V18.1709Z",
    fill: "#AB0101",
    mask: "url(#path-10-inside-5_799_2202)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 17.1693,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 17.1693C17.0003 16.4854 17.5514 16.1676 17.9289 16.1676V20.1676C19.4898 20.1676 21.0003 18.9559 21.0003 17.1693H17.0003ZM17.9289 16.1676C18.3063 16.1676 18.8574 16.4854 18.8574 17.1693H14.8574C14.8574 18.9559 16.3679 20.1676 17.9289 20.1676V16.1676ZM18.8574 17.1693C18.8574 17.8531 18.3063 18.1709 17.9289 18.1709V14.1709C16.3679 14.1709 14.8574 15.3826 14.8574 17.1693H18.8574ZM17.9289 18.1709C17.5514 18.1709 17.0003 17.8531 17.0003 17.1693H21.0003C21.0003 15.3826 19.4898 14.1709 17.9289 14.1709V18.1709Z",
    fill: "#AB0101",
    mask: "url(#path-12-inside-6_799_2202)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-7_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 13.5091C9.14286 12.8252 9.69398 12.5075 10.0714 12.5075V16.5075C11.6323 16.5075 13.1429 15.2958 13.1429 13.5091H9.14286ZM10.0714 12.5075C10.4489 12.5075 11 12.8252 11 13.5091H7C7 15.2958 8.51052 16.5075 10.0714 16.5075V12.5075ZM11 13.5091C11 14.193 10.4489 14.5107 10.0714 14.5107V10.5107C8.51052 10.5107 7 11.7225 7 13.5091H11ZM10.0714 14.5107C9.69398 14.5107 9.14286 14.193 9.14286 13.5091H13.1429C13.1429 11.7225 11.6323 10.5107 10.0714 10.5107V14.5107Z",
    fill: "#AB0101",
    mask: "url(#path-14-inside-7_799_2202)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-8_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0706 13.5091C13.0706 12.8252 13.6217 12.5075 13.9992 12.5075V16.5075C15.5601 16.5075 17.0706 15.2958 17.0706 13.5091H13.0706ZM13.9992 12.5075C14.3766 12.5075 14.9277 12.8252 14.9277 13.5091H10.9277C10.9277 15.2958 12.4383 16.5075 13.9992 16.5075V12.5075ZM14.9277 13.5091C14.9277 14.193 14.3766 14.5107 13.9992 14.5107V10.5107C12.4383 10.5107 10.9277 11.7225 10.9277 13.5091H14.9277ZM13.9992 14.5107C13.6217 14.5107 13.0706 14.193 13.0706 13.5091H17.0706C17.0706 11.7225 15.5601 10.5107 13.9992 10.5107V14.5107Z",
    fill: "#AB0101",
    mask: "url(#path-16-inside-8_799_2202)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-9_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 13.5091,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 13.5091C17.0003 12.8252 17.5514 12.5075 17.9289 12.5075V16.5075C19.4898 16.5075 21.0003 15.2958 21.0003 13.5091H17.0003ZM17.9289 12.5075C18.3063 12.5075 18.8574 12.8252 18.8574 13.5091H14.8574C14.8574 15.2958 16.3679 16.5075 17.9289 16.5075V12.5075ZM18.8574 13.5091C18.8574 14.193 18.3063 14.5107 17.9289 14.5107V10.5107C16.3679 10.5107 14.8574 11.7225 14.8574 13.5091H18.8574ZM17.9289 14.5107C17.5514 14.5107 17.0003 14.193 17.0003 13.5091H21.0003C21.0003 11.7225 19.4898 10.5107 17.9289 10.5107V14.5107Z",
    fill: "#AB0101",
    mask: "url(#path-18-inside-9_799_2202)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-10_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 20.4974C9.14286 19.8135 9.69398 19.4958 10.0714 19.4958V23.4958C11.6323 23.4958 13.1429 22.284 13.1429 20.4974H9.14286ZM10.0714 19.4958C10.4489 19.4958 11 19.8135 11 20.4974H7C7 22.284 8.51052 23.4958 10.0714 23.4958V19.4958ZM11 20.4974C11 21.1813 10.4489 21.499 10.0714 21.499V17.499C8.51052 17.499 7 18.7107 7 20.4974H11ZM10.0714 21.499C9.69398 21.499 9.14286 21.1813 9.14286 20.4974H13.1429C13.1429 18.7107 11.6323 17.499 10.0714 17.499V21.499Z",
    fill: "#AB0101",
    mask: "url(#path-20-inside-10_799_2202)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-11_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9992,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0706 20.4974C13.0706 19.8135 13.6217 19.4958 13.9992 19.4958V23.4958C15.5601 23.4958 17.0706 22.284 17.0706 20.4974H13.0706ZM13.9992 19.4958C14.3766 19.4958 14.9277 19.8135 14.9277 20.4974H10.9277C10.9277 22.284 12.4383 23.4958 13.9992 23.4958V19.4958ZM14.9277 20.4974C14.9277 21.1813 14.3766 21.499 13.9992 21.499V17.499C12.4383 17.499 10.9277 18.7107 10.9277 20.4974H14.9277ZM13.9992 21.499C13.6217 21.499 13.0706 21.1813 13.0706 20.4974H17.0706C17.0706 18.7107 15.5601 17.499 13.9992 17.499V21.499Z",
    fill: "#AB0101",
    mask: "url(#path-22-inside-11_799_2202)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-12_799_2202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9289,
    cy: 20.4974,
    rx: 1.07143,
    ry: 0.998363,
    fill: "#AB0101"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 20.4974C17.0003 19.8135 17.5514 19.4958 17.9289 19.4958V23.4958C19.4898 23.4958 21.0003 22.284 21.0003 20.4974H17.0003ZM17.9289 19.4958C18.3063 19.4958 18.8574 19.8135 18.8574 20.4974H14.8574C14.8574 22.284 16.3679 23.4958 17.9289 23.4958V19.4958ZM18.8574 20.4974C18.8574 21.1813 18.3063 21.499 17.9289 21.499V17.499C16.3679 17.499 14.8574 18.7107 14.8574 20.4974H18.8574ZM17.9289 21.499C17.5514 21.499 17.0003 21.1813 17.0003 20.4974H21.0003C21.0003 18.7107 19.4898 17.499 17.9289 17.499V21.499Z",
    fill: "#AB0101",
    mask: "url(#path-24-inside-12_799_2202)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsRed);
export default __webpack_public_path__ + "static/media/hotels-red.92a975cbc5de17badea5060fc14fadcd.svg";
export { ForwardRef as ReactComponent };